import React, { useState } from "react";
import AppBarCommon from "../AppBarCommon";
import { Tabs, Tab, Box } from "@mui/material";
import Settings from "./Settings";
import EmailConfiguration from "./EmailConfiguration";
import StorageConfiguration from "./StorageConfiguration";
import SSOConfiguration from "./SSOConfiguration";
import SystemUpdate from "./SystemUpdate";
import ExportManager from "../common/ExportManager";
import { isSuperAdminFromToken, isAdminFromToken } from "../../utils/jwtUtils";

const UserManagement = () => {
  const [tab, setTab] = useState(0);
  const [openUserModal, setOpenUserModal] = useState(false);
  const isSuperAdmin = isSuperAdminFromToken();
  const isAdmin = isAdminFromToken();

  const handleUser = () => {
    setOpenUserModal(true);
  };

  return (
    <div
      style={{
        paddingTop: "96px",
        height: "100vh",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        padding: "96px 0 0 0",
      }}
    >
      <AppBarCommon name="Settings" />

      <Box sx={{ flex: 1, minHeight: 0, padding: "20px 24px", display: "flex", flexDirection: "column" }}>
        <Tabs
          value={tab}
          onChange={(e, newValue) => setTab(newValue)}
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            mb: 1,

            "& .MuiTabs-flexContainer": {
              alignItems: "flex-end",
            },

            "& .MuiTab-root": {
              textTransform: "none",
              fontSize: "14px",
              fontWeight: 500,
              minHeight: "44px",
              padding: "10px 22px",
              border: "1px solid #cfd8dc",
              borderBottom: "none",
              borderTopLeftRadius: "6px",
              borderTopRightRadius: "6px",
              backgroundColor: "#eef4f6",
              color: "#49758d",
              marginRight: "6px",
              transition: "all 0.2s ease",
            },

            "& .MuiTab-root:hover": {
              backgroundColor: "#e3eef2",
            },

            "& .Mui-selected": {
              backgroundColor: "#ffffff",
              color: "#49758d !important",
              fontWeight: 600,
              borderColor: "#49758d",
              borderBottom: "1px solid white",
              position: "relative",
              top: "1px",
            },
          }}
        >
          <Tab label="User Management" />
          {isAdmin && <Tab label="Email Configuration" />}
          {isAdmin && <Tab label="Storage Configuration" />}
          {isAdmin && <Tab label="SSO Configuration" />}
          {isAdmin && <Tab label="System Update" />}
          <Tab label="Exports" />
        </Tabs>

        {tab === 0 && (
          <Settings
            handleUser={handleUser}
            openUserModal={openUserModal}
            setOpenUserModal={setOpenUserModal}
          />
        )}
        {tab === 1 && isAdmin && <EmailConfiguration />}
        {tab === 2 && isAdmin && <StorageConfiguration />}
        {tab === 3 && isAdmin && <SSOConfiguration />}
        {tab === 4 && isAdmin && <SystemUpdate />}
        {((tab === 1 && !isAdmin) || (tab === 5 && isAdmin)) && <ExportManager />}
      </Box>
    </div>
  );
};

export default UserManagement;
